import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import VehicleModel from "../../models/masters/vehicle-model";


const url = getEndPoint(API_END_POINT.MASTER) +"/api/Vehicle/GetAllVehicle";// //{/api/Vehicle/GetAllVehicle}`)  //// "https://localhost:7054/api/Vehicle/GetAllVehicle";
export const useGetVehicles = createQuery<
  VehicleModel[],
  null,
  AxiosError
>({
  queryKey: ["keyVehiclelist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});